<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    date(){
      return {
        showiframe: false,
        src: ''
      }
    },
    mounted(){
        window.addEventListener('message', function(event) {
            var result = event.data;
            if (result.success){
                console.log('最顶消息');
                window.top.location.href = result.pay_url;
            }
        });
        if((('standalone' in window.navigator) && window.navigator.standalone) || window.matchMedia('(display-mode: standalone)').matches){
              if (self.frameElement && self.frameElement.tagName == "IFRAME") return
              localStorage.setItem('is_standalone', 'true')
              document.querySelector('#app').style.display = 'none'
              const iframe = document.createElement('iframe')
              const iframeBg = document.createElement('iframeBg')
              iframeBg.style.width = '100vw'
              iframeBg.style.height = '100vh'
              iframeBg.style.zIndex = '999990' 
              iframeBg.style.position = 'fixed'
              iframeBg.style.backgroundColor = "#ffffff"
              iframe.setAttribute("src",window.origin); 
              iframe.style.width = '100vw'
              iframe.style.height = '93vh' 
              // iframe.style.height = '100vh' 
              iframe.style.zIndex = '999999' 
              iframe.style.position = 'fixed'
              iframe.style.overflowY = 'none'
              iframe.id = 'iframex'
              iframe.setAttribute("width", '100%');
              iframe.setAttribute("overflow", 'visible');
              iframe.setAttribute("frameBorder", '0');
              
              iframe.setAttribute("top", '100px');
              // iframe.style.left = '10vw'
              // iframe.style.top = '10vw'
              document.querySelector('body').appendChild(iframe)
              document.querySelector('body').appendChild(iframeBg)

        }
          

    }
  }
  
</script>

<style>
</style>